<template>
    <div class="credit-card-new-form">
        <FormRow label="Enter your credit card info" :error="error">
            <div ref="card" />

            <template #help>
                <slot name="link" />
            </template>
        </FormRow>
    </div>
</template>

<script>
import { FormRow } from '@/components/Form';

export default {
    components: {
        FormRow,
    },

    props: {
        error: {
            type: String,
            default: null,
        },
        onMount: {
            type: Function,
            default: null,
        },
    },

    /**
     * Handles "mounted" hook.
     */
    mounted() {
        if (this.onMount) {
            this.onMount(this.$refs.card);
        }
    },
};
</script>
<style scoped lang="scss">
    @use './CreditCardNewForm.scss';
</style>
